<template>
	<div class="search-bar-multikey">
		<div class="card-base search-bar-multikey-grid-container" :style="`background-color: ${this.searchDesign.bg_color ?? '#FFFFFF'}; color: ${this.searchDesign.text_color ?? '#000000'} !important;`">
			<div class="search-bar-multikey-header">
				<h4 :style="`color: ${this.searchDesign.text_color ?? '#000000'} !important;`">
					{{ translate('search-engine') }}
				</h4>
			</div>
			<div>
				<vue-select-unit
						:options="{
						slug: 'search-location',
						placeholder:this.translate('where-search-adverts'),
						taggable: true,
						multiple: true,
						class: 'search-bar-select-input',
						noDrop: true,
						label: 'name',
						getOptionKey: (option) => {
							return option.probond_id;
						},
						onOpen: modalOpen,
						showInput: !this.inputValues.locations || this.inputValues.locations.length === 0
					}"
						v-model="inputValues.locations"
				>
				</vue-select-unit>
			</div>

			<div>
				<vue-select-unit
						:options="{
						slug: 'categories',
						placeholder: translate('advert-category'),
						class: 'search-bar-select-input',
						label: 'name',
						options: this.categoriesData,
						reduceFn: (v => v.slug),
						required: false,
					}"
						v-model="inputValues.categories"
				>
				</vue-select-unit>
			</div>

			<div class="search-bar-keyword">
				<input-unit
						:options="{
						placeholder:translate('advert-position-keyword'),
						name:'',
						slug: 'keyword',
						class: 'search-bar-inputs'
					}"
						v-model="inputValues.keyword"
				/>
			</div>
			<div class="search-bar-actions">
				<button-unit
						class="search-bar-multikey-button"
						@click-on-btn="search"
						:options="{
						shape: ButtonUnitShape.ROUNDED,
						text: translate('general-search'),
						bgColor: this.searchDesign.button.bg_color ?? '#FFFFFF',
						textColor: this.searchDesign.button.text_color ?? '#000000',
					}"
				/>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import VueSelectUnit from "../Units/VueSelectUnit.vue";
import ButtonUnit from "../Units/ButtonUnit.vue";
import InputUnit from "../Units/InputUnit.vue";
import {ButtonUnitShape} from "../Units/Interfaces/ButtonUnitShape";
import {CarouselSearchInterface} from "../Interfaces/CarouselSection/CarouselSearchInterface";
import {CategoryShowTypeEnum} from "@SharedEnums/Carousel/CategoryShowTypeEnum";
import {useSearchDataStore} from "@WebApp/Stores/SearchData/SearchDataStore";

export default defineComponent({
	name: "SearchBarMultiKey",
	components: {VueSelectUnit, ButtonUnit, InputUnit},
	props: {
		searchDesign: {
			type: Object as PropType<CarouselSearchInterface>,
			required: true,
		}
	},
	inject: ['emitter'],
	setup() {
		return {
			searchDataStore: useSearchDataStore()
		}
	},
	data() {
		return {
			inputValues: {},
		}
	},
	methods: {
		modalOpen(): void {
			this.emitter.emit('onModalShow_advert-search-location-modal', this.inputValues.locations ?? []);
		},
		search() {
			const locations = this.inputValues?.locations?.map((value: string) => value.slug);
			const search = JSON.stringify({name: this.inputValues?.keyword ?? ''});
			this.$router.push({
				name: 'adverts',
				params: {
					categories: this.inputValues?.categories ?? 'osszes',
					locations: Array.isArray(locations) ? locations.join(';') : 'osszes',
					territorials: Array.isArray(locations) ? locations.join(';') : 'osszes',
				},
				query: {
					search: btoa(search)
				}
			});
		},
	},
	computed: {
		ButtonUnitShape() {
			return ButtonUnitShape;
		},
		categoriesData() {
			if (this.searchDesign.category_type === CategoryShowTypeEnum.SUB_CATEGORY) {
				return this.searchDataStore.categories.flatMap(item => item.children);
			} else if (this.searchDesign.category_type === CategoryShowTypeEnum.ALL_CATEGORY) {
				return this.searchDataStore.categories.flatMap(item => [item, ...item.children.flatMap(child => child)]);
			} else {
				// CategoryShowTypeEnum.MAIN_CATEGORY
				return this.searchDataStore.categories;
			}
		}
	},
	mounted() {
		this.emitter.on('onAdvertLocationSearch', (searchLocationData) => {
			this.inputValues.locations = searchLocationData;
			this.emitter.emit('onModalClose_advert-search-location-modal');
		});
	},
	beforeUnmount() {
		this.emitter.off('onAdvertLocationSearch');
	},
});
</script>

<style lang="scss" scoped>

</style>
